import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-painel-ativacao-terminal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './painel-ativacao-terminal.component.html'
})
export class PainelAtivacaoTerminalComponent {
  @Input() codigoAtivacao = '';
  @Input() ativandoTerminal = false;

  @Output() codigoAtivacaoChange = new EventEmitter<string>();
  @Output() ativarTerminal = new EventEmitter<void>();
}
